const AlignToGoalsTabContent = () => {
    return <div>Content for Align To Goals Tab</div>;
};

export { AlignToGoalsTabContent };
